window.FinsweetAttributes ||= [];
window.FinsweetAttributes.push([
  'list',
  (listInstances: FinsweetListInstance[]) => {
    const listInstance = listInstances[0]; // Assuming there's only one list on the page

    interface Department {
      id: number;
      name: string;
      children: Department[];
      jobs: Job[];
    }

    interface Job {
      absolute_url: string;
      title: string;
      location: { name: string };
      departments: { name: string; parent_id?: number }[];
    }

    // console.log(listInstance);
    async function getDepartments() {
      const GREENHOUSE_API_URL =
        'https://boards-api.greenhouse.io/v1/boards/engine/departments?render_as=tree';

      const departmentSelect = document.querySelector<HTMLSelectElement>('[data-el="departments"]');
      const heading = document.querySelector<HTMLElement>('[data-el="heading"]');

      departmentSelect?.addEventListener('change', (e: Event) => {
        const target = e.target as HTMLSelectElement;
        if (!target?.value) {
          if (heading) heading.textContent = 'Open positions';
          return;
        }
        if (heading) heading.textContent = `${target.value} positions`;
      });

      try {
        const response = await fetch(GREENHOUSE_API_URL);
        if (!response.ok) {
          throw new Error(`Response status: ${response.status}`);
        }

        const data: { departments: Department[] } = await response.json();
        const { departments } = data;
        // console.log(departments);
        const options: string[] = [];

        departments.forEach((department) => {
          if (department.name.startsWith('*')) return;
          if (!department.jobs.length && !department.children.length) return;
          if (department.children.length) {
            const childOptions = department.children
              .map((child) => `<option value='${child.name}'>${child.name}</option>`)
              .join('');

            options.push(`
              <optgroup label="${department.name}">
                ${childOptions}
              </optgroup>
            `);
          } else {
            options.push(`<option value='${department.name}'>${department.name}</option>`);
          }
        });

        if (departmentSelect) {
          departmentSelect.innerHTML += options.join('');
        }

        fetchJobs(departments);
      } catch (error) {
        console.error('Failed to fetch departments:', error);
      }
    }

    async function fetchJobs(departments: Department[]) {
      const loader = document.querySelector<HTMLElement>('[data-el="loader"]');
      const jobList = document.querySelector<HTMLElement>('[data-el="jobs"]');
      const template = document.querySelector<HTMLElement>('[data-el="job-item"]');
      const listParent = template?.parentElement;

      if (!loader || !jobList || !template || !listParent) return;

      loader.style.display = 'flex';

      try {
        const res = await fetch(
          'https://boards-api.greenhouse.io/v1/boards/engine/jobs?content=true'
        );
        const data: { jobs: Job[] } = await res.json();
        const { jobs } = data;

        // console.log(jobs);

        const locationSelect = document.querySelector<HTMLSelectElement>('[data-el="locations"]');

        function getUniqueJobLocations(jobs: Job[]): string[] {
          const locationSet = new Set<string>();
          jobs.forEach((job) => {
            if (job.location?.name) {
              locationSet.add(job.location.name);
            }
          });
          return Array.from(locationSet);
        }

        const locations = getUniqueJobLocations(jobs);
        const locationOptions: string[] = [];

        locations.forEach((location) => {
          locationOptions.push(`<option value='${location}'>${location}</option>`);
        });

        if (locationSelect) {
          locationSelect.innerHTML = `<option value="">All locations</option>${locationOptions.join('')}`;
        }

        // Clear all previous items except template
        listParent
          .querySelectorAll('[data-el="job-item"]:not(:first-child)')
          .forEach((el) => el.remove());

        const newItems = jobs.map((job) => {
          const jobEl = template.cloneNode(true) as HTMLElement;
          jobEl.style.display = '';

          const link = jobEl.querySelector<HTMLAnchorElement>('[data-el="job-link"]');
          const title = jobEl.querySelector<HTMLElement>('[data-el="job-title"]');
          const location = jobEl.querySelector<HTMLElement>('[data-el="job-location"]');
          const department = jobEl.querySelector<HTMLElement>('[data-el="job-department"]');
          const parentDepartment = jobEl.querySelector<HTMLElement>(
            '[data-el="job-parent-department"]'
          );

          if (link) link.href = job.absolute_url || '#';
          if (title) title.textContent = job.title || '';
          if (department) department.textContent = job.departments[0]?.name || '';
          if (location) location.textContent = job.location?.name || '';

          if (parentDepartment) parentDepartment.style.display = 'none';

          const parentId = job.departments[0]?.parent_id;
          if (parentId) {
            const parent = departments.find((dept) => dept.id === parentId);
            if (parent && parentDepartment) {
              parentDepartment.style.display = 'inline';
              parentDepartment.textContent = `${parent.name} ->`;
            }
          }

          // Add fs-list-field attributes
          if (department) department.setAttribute('fs-list-field', 'department');
          if (location) location.setAttribute('fs-list-field', 'location');

          return listInstance.createItem(jobEl);
        });

        listInstance.items.value = newItems;
        loader.style.display = 'none';
        jobList.style.display = 'flex';
      } catch (error) {
        console.error('Error fetching jobs:', error);
        loader.style.display = 'none';
      }
    }

    getDepartments();
  },
]);
